var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.icon,'sider-trigger-a', _vm.collapse ? 'collapsed' : ''],attrs:{"title":_vm.title,"type":"text"},on:{"click":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }